import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUIDescription } from "./customerGroupDetails/AssigningCustomerGroupDevice";

export default function AddGroupForm({ open, onClose, onSubmit }) {
  const [type, setType] = useState("geographical");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const PREFIX = "PRC - ";
  const fullName = PREFIX + name;

  const handleAddGroup = async () => {
    try {
      setLoading(true);

      const payload = {
        companyId: process.env.REACT_APP_COMPANY_ID,
        type,
        name: fullName, // Send with prefix
        description,
        UI_Description: `${getUIDescription()}\n Add precision unit Group` ,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/groups`,
        payload
      );

      if (onSubmit) {
        onSubmit(response.data);
      }

      // Reset form after submit
      setType("geographical");
      setName("");
      setDescription("");

      console.log("✅ Group created:", response.data);
      toast.success("✅ Group created successfully!");

    } catch (error) {
      console.error(
        "❌ Error creating group:",
        error.response?.data || error.message
      );
      toast.error(error.response?.data?.message || "❌ Failed to create group");

    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New PU Group</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>

          <TextField
           sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0, // ✅ remove rounding
                      },
                    }}

            select
            label="Type *"
            value="geographical"
            fullWidth
            disabled
          >
            <MenuItem value="geographical">Geographical</MenuItem>
          </TextField>

          <TextField
           sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0, // ✅ remove rounding
                      },
                    }}

            label="Name *"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    {PREFIX}
                  </Box>
                </InputAdornment>
              ),
            }}
            placeholder="group name"
            helperText={name ? `Full name: ${fullName}` : "Enter group name"}
          />

          <TextField
           sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0, // ✅ remove rounding
                      },
                    }}

            label="Description *"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
          />

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancel
        </Button>
        <Button
         sx={{
                        borderRadius: 0, // ✅ remove rounding
                    }}
          onClick={handleAddGroup}
          variant="contained"
          color="primary"
          disabled={loading || !name || !description}
        >
          {loading ? "Adding..." : "Add Group"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}